import type { Note } from './dto.notes';

export interface TransformedComment {
  id: string;
  author: string;
  initials: string;
  role: string;
  timestamp: string;
  message: string;
}

/**
 * Get initials from a full name
 * @param fullName - The full name to extract initials from
 * @returns Two-letter initials in uppercase
 */
export const getInitials = (fullName: string): string => {
  if (!fullName) return '??';
  const names = fullName.trim().split(' ');
  if (names.length === 1) return names[0].substring(0, 2).toUpperCase();
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
};

/**
 * Transform a single Note from API response to component-friendly Comment format
 * @param note - The note from API response
 * @returns Transformed comment object
 */
export const transformNote = (note: Note): TransformedComment => ({
  id: note.noteIdentifier,
  author: note.createdBy?.fullName || 'Unknown User',
  initials: getInitials(note.createdBy?.fullName || ''),
  role: 'User', // API doesn't provide role, using default
  timestamp: note.createdAt,
  message: note.noteContent,
});

/**
 * Transform an array of Notes from API response to component-friendly Comments format
 * @param notes - Array of notes from API response
 * @returns Array of transformed comment objects
 */
export const transformComments = (notes: Note[] | undefined | null): TransformedComment[] => {
  if (!notes || !Array.isArray(notes)) return [];
  return notes.map(transformNote);
};
